var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input, Select } from "semantic-ui-react";
import { formatMonetaryDecimal } from "../kit/rna-fish/EditKitForm";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { parseMonetaryInput } from "./AddOrderShipmentTracking";
var AddLineItemModal = /** @class */ (function (_super) {
    __extends(AddLineItemModal, _super);
    function AddLineItemModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onTypeChange = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value: " + val);
            }
            _this.setState({
                type: val
            });
        };
        _this.onNoteChange = function (event, data) {
            var str = data.value;
            _this.setState({ note: str });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/line-items", {
                type: _this.state.type,
                note: _this.state.note,
                amountCents: _this.state.amountCents
            });
        };
        _this.onAmountChange = function (event) {
            var cents = parseMonetaryInput(event.currentTarget.value);
            if (cents !== undefined) {
                _this.setState({
                    amountCents: cents
                }, function () {
                    _this.props.setState(function (oldState) {
                        var filtered = oldState.errors.filter(function (e) { return e.path !== '/amountCents'; });
                        return {
                            errors: filtered,
                        };
                    });
                });
            }
            else {
                _this.props.setState(function (oldState) {
                    var filtered = oldState.errors.filter(function (e) { return e.path !== '/amountCents'; });
                    return {
                        errors: filtered.concat({ msg: 'Invalid amount', path: '/amountCents' }),
                    };
                });
            }
        };
        _this.state = {
            amountCents: 0,
            type: '',
            note: ''
        };
        return _this;
    }
    AddLineItemModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { disabled: this.props.state.success, errorPath: '/type', errors: this.props.state.errors, required: true, labelContent: 'Type' },
                React.createElement(Select, { search: true, onChange: this.onTypeChange, options: [
                        {
                            value: 'MISC',
                            text: 'Misc'
                        },
                        {
                            value: 'SHIPPING_HANDLING',
                            text: 'Shipping & handling'
                        },
                        {
                            value: 'TAX',
                            text: 'Tax'
                        }
                    ], value: this.state.type })),
            React.createElement(FieldWithErrorDisplay, { disabled: this.props.state.success, errorPath: '/note', errors: this.props.state.errors, required: true, labelContent: 'Note' },
                React.createElement(Input, { onChange: this.onNoteChange, placeholder: 'Shipping', value: this.state.note })),
            React.createElement(FieldWithErrorDisplay, { disabled: this.props.state.success, errors: this.props.state.errors, errorPath: '/amountCents', labelContent: React.createElement(React.Fragment, null, "Amount"), required: true },
                React.createElement(Input, { onChange: this.onAmountChange }),
                React.createElement("div", { style: { color: 'grey' } },
                    "\u2937 Parsed as: $",
                    formatMonetaryDecimal(this.state.amountCents))),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Add line item', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return AddLineItemModal;
}(React.PureComponent));
export default AddLineItemModal;
;
//# sourceMappingURL=AddLineItemModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddLineItemModal.js
// module id = 1095
// module chunks = 0